import * as Sentry from '@sentry/react';
import { Route } from 'react-router-dom';
import { Routes } from 'react-router-dom-v5-compat';

export const SentryRoute = Sentry.withSentryRouting(Route);

/**
 * We're using Sentry.withSentryReactRouterV6Routing(Routes) so we can get the most out of Sentry's routing
 * instrumentation despite not using the Sentry.reactRouterV6BrowserTracingIntegration() integration.
 *
 * Sentry.withSentryReactRouterV6Routing(Routes) still works because Routes uses the v5-to-v6 compatibility layer
 * which still makes it compatible with the v5 router context.
 */
export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
